import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import { ThemeSwitch } from '@helpers/theme';
import { BreadcrumbsStyles } from '@stories/Widgets/Meta/Breadcrumbs/Breadcrumbs.styles';
import styled from 'styled-components';
const Wrapper = styled.section `
  min-height: clamp(160px, 10vw, 300px);
  ${ThemeSwitch({ groundforceColour: brand.primary.dark })}
  background-color: var(--theme);
  padding: 15px 0px;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 80%);

  h1 {
    color: ${brand.white};
    text-transform: none;
    margin-top: 20px;
    margin-bottom: 10vw;
    grid-column: span 12;

    @media ${from(Device.Tablet)} {
      grid-column: 2 / span 10;
    }
  }

  ${BreadcrumbsStyles.Inner} {
    color: ${brand.white};

    a {
      color: ${brand.white};
    }
  }
`;
export const InnerBannerStyles = {
    Wrapper,
};
